var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgQuestion = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M18,34A16,16,0,1,1,34,18,16,16,0,0,1,18,34ZM18,2.914A15.086,15.086,0,1,0,33.086,18,15.086,15.086,0,0,0,18,2.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M21.981,34.629A12.648,12.648,0,1,1,34.629,21.981,12.648,12.648,0,0,1,21.981,34.629Zm0-24.381A11.734,11.734,0,1,0,33.714,21.981,11.734,11.734,0,0,0,21.981,10.248Z",
    transform: "translate(-3.981 -3.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M31.692,33.039a.457.457,0,0,1-.457-.457,4.895,4.895,0,0,1,2.357-4.109,3.531,3.531,0,0,0,1.653-3.109,3.6,3.6,0,0,0-3.452-3.452,3.555,3.555,0,0,0-3.657,3.553.457.457,0,0,1-.914,0A4.469,4.469,0,0,1,31.818,21a4.523,4.523,0,0,1,4.343,4.343,4.438,4.438,0,0,1-2.079,3.9,3.985,3.985,0,0,0-1.933,3.337A.457.457,0,0,1,31.692,33.039Z",
    transform: "translate(-13.692 -10.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M36.457,51.292A.457.457,0,0,1,36,50.834V50.31a.457.457,0,0,1,.914,0v.524A.457.457,0,0,1,36.457,51.292Z",
    transform: "translate(-18.457 -25.977)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.7e5cd05c.svg";
export { ForwardRef as ReactComponent };